import { ConditionalLink } from "components/conditionalLink";
import { Banner } from "components/DesignSystem/Banner/Banner";
import { Button } from "components/DesignSystem/Button/Button";
import { SmallArrowUpRight } from "components/icons/SmallArrowUpRight";

export const LaunchedRAndDFilingView = ({ taskId }: { taskId: string }) => (
  <Banner
    type="info"
    title="Your Form 6765 (R&D credits) is launched"
    description="Your Form 6765 (R&D credits) filing is launched. Any updates or uploads required will be reflected there."
    cta={
      <ConditionalLink to={`/tax/filings/${taskId}`} target="_blank">
        <span>
          <Button
            size="xsmall"
            type="button"
            rightIcon={<SmallArrowUpRight className="!t-size-2" />}
          >
            Go to filing
          </Button>
        </span>
      </ConditionalLink>
    }
  />
);
